export const ROUTE_EXPORT_ID = 'route';

export const ROUTE_TITLE = 'Territorios';

export const LOCALIZED_PROPERTIES = {
  externalKeys: 'Código',
  name: 'Nombre',
  company: 'Compañia',
  statusId: 'Estado',
};
